"use client";

import React from "react";
import { featuresItems } from "./somaContent";

type Props = object;

function SomaFeatures({}: Props) {
  return (
    <section id="features" className="px-4 py-20 md:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-4xl">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {featuresItems.map((feature, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl p-[1px] transition-all duration-300"
              style={{
                background:
                  "radial-gradient(61.36% 139.46% at 39% 31.82%, #FCFCFC 0%, #505050 69.63%)",
              }}
            >
              <div className="relative h-full rounded-xl bg-[#0B0B0B] p-6">
                {/* Shiny sphere indicator */}
                <div className="mb-4 flex items-center gap-3">
                  <div
                    className="h-2.5 w-2.5 flex-shrink-0 rounded-full"
                    style={{
                      background:
                        "radial-gradient(58.33% 58.33% at 50% 41.67%, rgba(255, 255, 255, 0.9) 0%, #505050 87.43%)",
                      boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
                    }}
                  />
                  <h3
                    className="text-lg font-semibold"
                    style={{
                      background:
                        "linear-gradient(135deg, #FCFCFC 0%, #A0A0A0 50%, #505050 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    {feature.title}
                  </h3>
                </div>

                <p className="text-sm leading-relaxed text-zinc-300">
                  {feature.description}
                </p>

                {/* Subtle hover glow effect */}
                <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-transparent via-white/5 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SomaFeatures;
